import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1);
const _hoisted_2 = {
  class: "offcanvas-body"
};
const _hoisted_3 = {
  class: "offcanvas-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["offcanvas d-flex flex-column flex-shrink-0", $options.compTheme])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["offcanvas-header", $options.compTheme])
  }, [_renderSlot(_ctx.$slots, "header"), _hoisted_1], 2), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer")])], 2);
}